import API from '../../sunwiseAPI';
const ENTITY = 'projected-years';

export const getData = (project_id, start_date) =>
    API.get(`/api/v1/${ENTITY}/sunpay/`, {
        params: { project_id, start_date },
    });
